export default __webpack_public_path__ + "static/media/close.cff32cbf.svg";